const downloadXLSX = (data, filename) => {
  const element = document.createElement('a')
  const file = new Blob([data], { type: 'text/plain' })
  element.href = URL.createObjectURL(file)
  element.download = `${filename}.xlsx`
  document.body.appendChild(element) // Required for this to work in FireFox
  element.click()
}

export default downloadXLSX
